module.exports = __webpack_public_path__ + "static/img/bgcbgc.96a6f132.png";